<template>
    <div class="page-layout__sidebar">

        <!--~~~~~     PAGE SIDEBAR     ~~~~~-->
        <div class="page-sidebar  page-sidebar-md">
            <div class="page-sidebar__logo">
                <div class="logo">
                    <router-link class="logo__link  justify-content-center" :to="{name:'api.application.getList'}" title="На главную">
                        <img class="logo__img" src="@/assets/img/logo__synak-test--full-light.svg" alt="SYNAK">
                    </router-link>
                </div>
            </div>
            <div class="page-sidebar__nav">
                <nav class="sidebar-nav">
                    <ul class="sidebar-nav__list">
                        <li class="sidebar-nav__item" :class="{'sidebar-nav__item--active' : $route.name && $route.name.includes('application')}">
                            <router-link class="sidebar-nav__link" :to="{name:'api.application.getList'}">
                                {{getTranslation('applications')}}
                            </router-link>
                        </li>
                        

                        <li class="sidebar-nav__item" :class="{'sidebar-nav__item--active' : $route.name && $route.name.includes('testing') && !$route.name.includes('structure')}">
                            <router-link class="sidebar-nav__link" :to="{name:'api.testing.getList'}">
                                {{getTranslation('testingTypes')}}
                            </router-link>
                        </li>

                        <li class="sidebar-nav__item" :class="{'sidebar-nav__item--active' : $route.name && $route.name.includes('testing.structure')}">
                            <router-link class="sidebar-nav__link" :to="{name:'api.testing.structure.getList'}">
                                {{getTranslation('testingStructure')}}
                            </router-link>
                        </li>
                    </ul>
                    
                    <!-- /sidebar-nav__list -->
                </nav>
                <!-- /sidebar-nav -->
            </div>
            <!-- /page-sidebar__nav -->
        </div>
        <!--~~~~~     / PAGE SIDEBAR     ~~~~~-->

    </div>
    <!-- /page-layout__sidebar -->

</template>

<script>
    export default {
        name: "AdminSidebar"
    }
</script>

<style scoped>

</style>
